(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lobo-discount-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const STORAGE_KEY = 'lobo_discount_popup_subscribed';
    const DISMISS_KEY = 'lobo_discount_popup_dismissed';

    const root = document.getElementById('LoboDiscountPopupRoot');
    if (!root) return;

    const form = document.getElementById('LoboDiscountPopupForm');
    const formPanel = root.querySelector('[data-lobo-popup-form-panel]');
    const successPanel = root.querySelector('[data-lobo-popup-success-panel]');
    const errorEl = root.querySelector('[data-lobo-error]');
    const submitBtn = root.querySelector('[data-lobo-submit]');
    const submitLabel = root.querySelector('[data-lobo-submit-label]');
    const spinner = root.querySelector('[data-lobo-spinner]');
    const emailConsentHidden = root.querySelector('[data-lobo-email-consent]');
    const emailCheckbox = root.querySelector('[data-lobo-email-checkbox]');
    const whatsappCheckbox = root.querySelector('[data-lobo-whatsapp-checkbox]');
    const copyBtn = root.querySelector('[data-lobo-copy-code]');
    const copiedEl = root.querySelector('[data-lobo-copied]');

    const delay = Number(root.dataset.delay || 3000);
    const cookieDays = Number(root.dataset.cookieDays || 7);

    function setDismissCookie() {
      const expires = new Date();
      expires.setDate(expires.getDate() + cookieDays);
      document.cookie = `${DISMISS_KEY}=1; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
    }

    function hasDismissCookie() {
      return document.cookie.split('; ').some((row) => row.startsWith(`${DISMISS_KEY}=`));
    }

    function openPopup() {
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const firstInput = form && form.querySelector('input:not([type="hidden"])');
      if (firstInput) firstInput.focus();
    }

    function closePopup() {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setDismissCookie();
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.hidden = false;
      errorEl.textContent = message;
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    function setLoading(isLoading) {
      if (!submitBtn) return;
      submitBtn.disabled = isLoading;
      if (submitLabel) submitLabel.hidden = isLoading;
      if (spinner) spinner.hidden = !isLoading;
    }

    function showSuccess() {
      if (formPanel) formPanel.hidden = true;
      if (successPanel) successPanel.hidden = false;
      localStorage.setItem(STORAGE_KEY, '1');
      setDismissCookie();
    }

    root.querySelectorAll('[data-lobo-popup-close]').forEach((el) => {
      el.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) closePopup();
    });

    if (localStorage.getItem(STORAGE_KEY) || hasDismissCookie()) return;

    window.setTimeout(openPopup, delay);

    if (emailCheckbox && emailConsentHidden) {
      emailCheckbox.addEventListener('change', () => {
        emailConsentHidden.value = emailCheckbox.checked ? 'true' : 'false';
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', async () => {
        const code = copyBtn.textContent.trim();
        try {
          await navigator.clipboard.writeText(code);
          if (copiedEl) copiedEl.hidden = false;
        } catch (_error) {
          window.prompt('Copia tu código:', code);
        }
      });
    }

    if (!form) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      clearError();

      if (!emailCheckbox.checked) {
        showError('Debes aceptar el marketing por email para continuar.');
        return;
      }

      if (!whatsappCheckbox.checked) {
        showError('Debes aceptar el marketing por WhatsApp para continuar.');
        return;
      }

      setLoading(true);

      const formData = new FormData(form);
      formData.set('form_type', 'customer');
      formData.set('utf8', '✓');

      if (whatsappCheckbox.checked) {
        const currentTags = formData.get('contact[tags]') || '';
        formData.set('contact[tags]', `${currentTags}, whatsapp-marketing-consent`);
      }

      try {
        const response = await fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'text/html',
          },
        });

        if (response.ok || response.redirected) {
          showSuccess();
          return;
        }

        showError('No pudimos guardar tus datos. Intenta de nuevo en unos segundos.');
      } catch (_error) {
        showError('Error de conexión. Revisa tu internet e intenta otra vez.');
      } finally {
        setLoading(false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lobo-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('lc-editorial')) return;
  class Editorial extends HTMLElement {
    connectedCallback() {
      this.destroy();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Set();
      this.galleries = [];
      this.canAnimate = () => this.dataset.motion === 'true' && !this.motion.matches && !window.Shopify?.designMode;
      const play = (node, frames) => {
        if (!this.canAnimate() || !node.animate) return;
        const animation = node.animate(frames, { duration: 750, easing: 'cubic-bezier(.22,1,.36,1)' });
        this.animations.add(animation);
        animation.onfinish = animation.oncancel = () => this.animations.delete(animation);
      };
      if ('IntersectionObserver' in window) {
        this.reveals = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.reveals.unobserve(entry.target);
          play(entry.target, [{ opacity: .45, transform: 'translateX(18px)' }, { opacity: 1, transform: 'translateX(0)' }]);
        }), { threshold: .12 });
        this.querySelectorAll('[data-reveal]').forEach(node => this.reveals.observe(node));
        this.chapters = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.querySelectorAll('[data-chapter-link]').forEach(link => {
            if (link.hash === '#' + entry.target.id) link.setAttribute('aria-current','location');
            else link.removeAttribute('aria-current');
          });
        }), { rootMargin: '-15% 0px -45% 0px', threshold: 0 });
        this.querySelectorAll('[data-chapter]').forEach(node => this.chapters.observe(node));
      }
      this.querySelectorAll('[data-gallery]').forEach(group => {
        const rail = group.querySelector('[data-rail]');
        const slides = [...rail.children];
        const prev = group.querySelector('[data-prev]');
        const next = group.querySelector('[data-next]');
        const counter = group.querySelector('[data-counter]');
        let current = 0, frame = 0;
        const update = () => {
          frame = 0;
          const left = rail.getBoundingClientRect().left;
          current = slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left-left) < Math.abs(slides[best].getBoundingClientRect().left-left) ? index : best, 0);
          prev.disabled = current === 0;
          next.disabled = current === slides.length-1;
          counter.textContent = `${String(current+1).padStart(2,'0')} / ${String(slides.length).padStart(2,'0')}`;
        };
        const go = index => {
          const slide = slides[Math.max(0,Math.min(index,slides.length-1))];
          rail.scrollTo({ left: rail.scrollLeft + slide.getBoundingClientRect().left - rail.getBoundingClientRect().left - 3, behavior: this.canAnimate() ? 'smooth' : 'instant' });
        };
        prev.addEventListener('click',()=>go(current-1),{signal});
        next.addEventListener('click',()=>go(current+1),{signal});
        rail.addEventListener('scroll',()=>{ if(!frame) frame=requestAnimationFrame(update); },{passive:true,signal});
        rail.addEventListener('keydown',event=>{
          if(event.target!==rail || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault(); go(current + (event.key==='ArrowRight'?1:-1));
        },{signal});
        window.addEventListener('resize',update,{passive:true,signal});
        group.querySelector('.lc-ed__controls').hidden = slides.length < 2;
        update();
        this.galleries.push({rail,slides,go,cancel:()=>cancelAnimationFrame(frame)});
      });
      this.addEventListener('click',event=>{
        const link = event.target.closest('[data-chapter-link]');
        if(!link) return;
        const target = this.querySelector(link.hash);
        if(!target) return;
        this.galleries.forEach(g=>{ const index=g.slides.indexOf(target); if(index>=0) g.go(index); });
      },{signal});
      document.addEventListener('shopify:block:select',event=>{
        if(!this.contains(event.target)) return;
        this.animations.forEach(a=>a.cancel());
        this.galleries.forEach(g=>{ const index=g.slides.findIndex(s=>s===event.target || s.contains(event.target)); if(index>=0) g.go(index); });
      },{signal});
      this.motion.addEventListener('change',()=>{if(this.motion.matches)this.animations.forEach(a=>a.cancel());},{signal});
    }
    disconnectedCallback() { this.destroy(); }
    destroy() { this.controller?.abort(); this.reveals?.disconnect(); this.chapters?.disconnect(); this.animations?.forEach(a=>a.cancel()); this.galleries?.forEach(g=>g.cancel()); }
  }
  customElements.define('lc-editorial',Editorial);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
